import React, { FC, ReactNode } from "react";
import "./link.css";

interface LinkProps {
  children: ReactNode;
  url: string;
  id?: string;
  className?: string;
}

const onLinkClick = (url: string) => {
  window.open(url);
};

export const Link: FC<LinkProps> = ({ children, className, id, url }) => (
  <button
    onClick={() => onLinkClick(url)}
    className={`Link ${className || ""}`}
    id={id}
  >
    <div className="content">{children}</div>
  </button>
);
